import { useState, useEffect } from 'react';

type UseNowProps = {
  disabled?: boolean;
  formatter?: (date: Date) => string;
  interval?: number;
};

export function useNow({
  disabled = false,
  interval = 1000, // 20 seconds
  formatter = (date: Date) =>
    date.toLocaleTimeString('sv-SE', {
      hour: '2-digit',
      minute: '2-digit',
    }),
}: UseNowProps) {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    if (disabled) {
      return;
    }

    const intervalId = setInterval(() => {
      setNow(new Date());
    }, interval);

    return () => clearInterval(intervalId);
  }, [disabled, interval]);

  return formatter(now);
}
